class Viewport {
  constructor(headerOffset) {
    this.height = window.innerHeight ||
      document.documentElement.clientHeight || document.body.clientHeight;
    this.width = window.innerWidth ||
      document.documentElement.clientWidth || document.body.clientWidth;
    this.top = window.pageYOffset + headerOffset;
    this.bottom = this.top + this.height - headerOffset;
  }
}

export default Viewport;
